module.exports = __webpack_public_path__ + "static/img/goods-main-img02.8729955c.svg";